import { motion, useTransform } from 'framer-motion';
import Redaction from '../Redaction';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const ProblemSection = ({ problemRef, problemRevealed, problemScroll }) => {
  const { isMobile } = useBreakpoint();

  // Transform scroll progress to opacity values
  // First text fades out as we scroll down
  const remembersOpacity = useTransform(problemScroll, [0.2, 0.4], [1, 0]);
  // Second text fades in as we scroll down
  const forgetOpacity = useTransform(problemScroll, [0.35, 0.5], [0, 1]);

  return (
    <section
      ref={problemRef}
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '20px' : 16,
        position: 'relative',
      }}
    >
      {/* First State: THE INTERNET REMEMBERS */}
      <motion.div
        style={{
          position: 'absolute',
          textAlign: 'center',
          fontSize: 'clamp(24px, 6vw, 56px)',
          fontWeight: 600,
          letterSpacing: '-0.04em',
          lineHeight: 1.2,
          opacity: remembersOpacity,
        }}
      >
        <h2 style={{ margin: 0 }}>THE INTERNET</h2>
        <h2 style={{ margin: 0 }}>
          <Redaction revealed={problemRevealed}>REMEMBERS.</Redaction>
        </h2>
      </motion.div>

      {/* Second State: MAKE IT FORGET */}
      <motion.h2
        style={{
          color: '#00FF41',
          margin: 0,
          textAlign: 'center',
          fontSize: 'clamp(24px, 6vw, 56px)',
          fontWeight: 600,
          letterSpacing: '-0.04em',
          lineHeight: 1.2,
          opacity: forgetOpacity,
        }}
      >
        MAKE IT FORGET.
      </motion.h2>
    </section>
  );
};

export default ProblemSection;
